import PromotionalMaterials from './PromotionalMaterials';
import RightSidebarPromMat from './RightSidebarPromMat';

import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(PromotionalMaterials, RightSidebarPromMat);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/PromotionalMaterials/index.js